import {createBrowserRouter} from "react-router-dom";

import Gallery from './components/Gallery';
import Landing from './components/Landing';
import Bio from "./components/Bio";
import Contact from "./components/Contact";
import Media from "./components/Media";
import Blog from "./components/Blog";
import Expose from "./components/Expose";
import './App.css';

const  router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />
  },
  {
    path: "/gallery",
    element: <Gallery />
  },
  {
    path: "/bio",
    element: <Bio />
  },
  {
    path: "/blog",
    element: <Blog />
  },
  {
    path: "/contact",
    element:  <Contact />
  },
  {
    path: "/media",
    element: <Media />
  },
  {
    path: "/expose/:slug",
    element: <Expose />
  }
]);

export default router;

